import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { RailStoreV2 } from '@kaltura-ott/tvpil-shared';

import { checkIsLogoRail } from './checkIsLogoRail';

export function checkIsRentalsRail(rail: RailStoreV2) {
  return rail?.subtype === UIDAPresentationTypeEnum.tvod && !checkIsLogoRail(rail);
}
